/// <amd-module name="WidgetCommon/ModernWidgetTypes/EmptySettingsManager" />
import { SettingsManagerBase } from "./SettingsManagerBase";

/**
 * Used by widget views that have incomplete default settings so they don't try to interpret partial custom settings.
 */
export class EmptySettingsManager extends SettingsManagerBase<undefined> {
    constructor(private featureName: string) {
        super();
    }

    public getFeatureName(): string {
        return this.featureName;
    }

    public generateDefaultSettings(): Promise<undefined> {
        // We use undefined here because the value null is stringified in JSON as the string "null" which means default settings has a value.
        // That is not the intention of this class which is to produce an empty default settings object to indicate unconfigured.
        // Undefined stays undefined through the pipeline.
        return Promise.resolve(undefined);
    }
}
